import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { convertThenFormat1 } from "../../common-data/Converts";
import { uploadImage } from "../../../redux/reducers/postApiSlice";
import { discrepancyOptions, getFormattedDate } from "../PayroleMocks";
import { fetchPayrollDetailData } from "../../../redux/payrole-reducers/payroleSlice";
import { CloudUploadIcon, HourglassIcon } from "../../../images/icons/icons";

const DiscrepancyForm = ({
  userInfoData,
  approvalType,
  formValues,
  payrollData,
  formErrors,
  selectedDates,
  setSelectedDates,
  // currentMonth,
  // discrepancyOptions,
  dateDiscrepancies,
  setDateDiscrepancies,
}) => {
  const dispatch = useDispatch();
  const { payrollDetailData, payrollDetailLoading, payrollDetailError } =
    useSelector((state) => state.payrole);

  const currentMonth = payrollData?.date
    ? new Date(payrollData.date)
    : new Date();

  const [allData, setAllData] = useState({});
  const [uploadingImages, setUploadingImages] = useState({});

  const getPayrollDetail = (filters) => {
    dispatch(
      fetchPayrollDetailData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];

    for (let i = 0; i < startingDayOfWeek; i++) {
      const prevMonthDay = new Date(year, month, -startingDayOfWeek + i + 1);
      days.push({
        date: prevMonthDay.getDate(),
        isCurrentMonth: false,
        fullDate: prevMonthDay,
      });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        date: day,
        isCurrentMonth: true,
        fullDate: new Date(year, month, day),
      });
    }

    const remainingCells = 42 - days.length;
    for (let i = 1; i <= remainingCells; i++) {
      const nextMonthDay = new Date(year, month + 1, i);
      days.push({
        date: nextMonthDay.getDate(),
        isCurrentMonth: false,
        fullDate: nextMonthDay,
      });
    }

    return days;
  };

  const getAttendanceType = (date) => {
    if (!allData?.calander || allData.calander.length === 0) {
      return "";
    }

    const dateString = moment.tz(date, "Asia/Kolkata").format("YYYY-MM-DD");
    const dayData = allData.calander.find((day) => day.date === dateString);

    if (!dayData) {
      return "";
    }

    if (dayData.is_leave_day === true) {
      return "leave";
    } else if (dayData.is_weekoff === true) {
      return "weekoff";
    } else if (dayData.is_sunday === true) {
      return "sunday";
    } else if (dayData.is_saturday === true) {
      return "saturday";
    } else if (dayData.is_rostered_day === true) {
      return "rostered";
    } else if (dayData.is_half_day === true) {
      return "half-day";
    } else if (dayData.is_late === true && dayData.is_present === true) {
      return "late";
    } else if (dayData.is_present === true) {
      return "present";
    } else if (dayData.is_absent === true) {
      return "absent";
    }

    return "";
  };

  const handleDateClick = (date) => {
    const dateString = date.toDateString();
    setSelectedDates((prev) => {
      if (prev.includes(dateString)) {
        const newDates = prev.filter((d) => d !== dateString);
        setDateDiscrepancies((prevDiscrepancies) => {
          const newDiscrepancies = { ...prevDiscrepancies };
          delete newDiscrepancies[dateString];
          return newDiscrepancies;
        });
        return newDates;
      } else {
        setDateDiscrepancies((prevDiscrepancies) => ({
          ...prevDiscrepancies,
          [dateString]: {
            discrepancyTypes: "",
            proofImages: [],
            remarks: "",
          },
        }));
        return [...prev, dateString];
      }
    });
  };

  const handleDiscrepancyChange = (dateString, discrepancyId) => {
    setDateDiscrepancies((prev) => ({
      ...prev,
      [dateString]: {
        ...prev[dateString],
        discrepancyTypes: discrepancyId,
      },
    }));
  };

  const handleRemarksChange = (dateString, remarks) => {
    setDateDiscrepancies((prev) => ({
      ...prev,
      [dateString]: {
        ...prev[dateString],
        remarks: remarks,
      },
    }));
  };

  const removeImage = (dateString, imageId) => {
    setDateDiscrepancies((prev) => {
      const dateData = prev[dateString];
      if (!dateData) return prev;

      const imageToRemove = dateData.proofImages.find(
        (img) => img.id === imageId
      );
      if (imageToRemove) {
        URL.revokeObjectURL(imageToRemove.preview);
      }

      return {
        ...prev,
        [dateString]: {
          ...dateData,
          proofImages: dateData.proofImages.filter((img) => img.id !== imageId),
        },
      };
    });
  };

  const handleImageUpload = async (e, dateString) => {
    const files = Array.from(e.target.files);
    const maxFiles = 5;

    const currentImages = dateDiscrepancies[dateString]?.proofImages || [];
    if (currentImages.length + files.length > maxFiles) {
      alert(`You can only upload a maximum of ${maxFiles} images per date`);
      return;
    }

    setUploadingImages((prev) => ({ ...prev, [dateString]: true }));

    try {
      const uploadPromises = files.map(async (file) => {
        const actionResult = dispatch(
          uploadImage({ file, TOKEN: userInfoData?.token })
        );
        const result = await actionResult;

        if (result?.payload?.status) {
          return {
            file,
            preview: URL.createObjectURL(file),
            id: Date.now() + Math.random(),
            url: result.payload.image_url,
          };
        } else {
          throw new Error(result?.error?.message || "Upload failed");
        }
      });

      const uploadedImages = await Promise.all(uploadPromises);
      setDateDiscrepancies((prev) => ({
        ...prev,
        [dateString]: {
          ...prev[dateString],
          proofImages: [
            ...(prev[dateString]?.proofImages || []),
            ...uploadedImages,
          ],
        },
      }));
      toast.success("Images uploaded successfully!");
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("Failed to upload images. Please try again.");
    } finally {
      setUploadingImages((prev) => ({ ...prev, [dateString]: false }));
    }
  };

  useEffect(() => {
    if (payrollData?.user_id && payrollData?.date) {
      const sendableFilters = {
        user_id: payrollData.user_id,
        month: getFormattedDate(payrollData),
      };

      getPayrollDetail(sendableFilters);
    }
  }, []);

  useEffect(() => {
    if (
      !payrollDetailLoading &&
      !payrollDetailError &&
      payrollDetailData?.status &&
      payrollDetailData?.data
    ) {
      setAllData(payrollDetailData.data);
    } else {
      setAllData({});
    }
  }, [payrollDetailLoading, payrollDetailError, payrollDetailData]);

  // console.log("allData=> ", allData?.calander);
  // console.log("payrollData=> ", payrollData);

  return (
    <div className="pp-rejected-review-section">
      {/* Instructional Guide */}
      <div className="pp-review-instructions">
        <div className="pp-review-instructions-header">
          <span className="pp-review-instructions-icon">📋</span>
          <h4 className="pp-review-instructions-title">
            Review & Report Discrepancies
          </h4>
        </div>

        <div className="pp-review-instructions-content">
          <p className="pp-review-instructions-text">
            Please review the salary breakdown and attendance calendar below.
            <strong>
              {" "}
              Click on calendar dates to select multiple dates
            </strong>{" "}
            where you found discrepancies, then specify the type of discrepancy
            for each selected date.
          </p>
          <div className="pp-review-instructions-steps">
            <div className="pp-review-instruction-step">
              <span className="pp-step-number">1</span>
              <span className="pp-step-text">
                Review salary summary and attendance calendar
              </span>
            </div>
            <div className="pp-review-instruction-step">
              <span className="pp-step-number">2</span>
              <span className="pp-step-text">
                Click on calendar dates to select multiple dates with issues
              </span>
            </div>
            <div className="pp-review-instruction-step">
              <span className="pp-step-number">3</span>
              <span className="pp-step-text">
                Specify discrepancy type and upload proof for each date
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="pp-rejected-review-wrapper">
        <div className="pp-salary-summary-card">
          <div className="pp-salary-summary-header">
            <h4 className="pp-salary-summary-title">Salary Summary</h4>
          </div>
          <div className="pp-salary-summary-content">
            <div className="pp-salary-summary-grid">
              <div className="pp-salary-summary-item">
                <span className="pp-salary-summary-label">Base Salary</span>
                <span className="pp-salary-summary-value">
                  ₹{convertThenFormat1(payrollData?.monthly_salary || 0)}
                </span>
              </div>
              <div className="pp-salary-summary-item">
                <span className="pp-salary-summary-label">Working Days</span>
                <span className="pp-salary-summary-value">
                  {payrollData?.total_days || 0}
                </span>
              </div>
              <div className="pp-salary-summary-item">
                <span className="pp-salary-summary-label">Full Days</span>
                <span className="pp-salary-summary-value full-days">
                  {payrollData?.total_present || 0}
                </span>
              </div>
              <div className="pp-salary-summary-item">
                <span className="pp-salary-summary-label">Half Days</span>
                <span className="pp-salary-summary-value half-days">
                  {payrollData?.total_half_day || 0}
                </span>
              </div>
              <div className="pp-salary-summary-item">
                <span className="pp-salary-summary-label">Absent Days</span>
                <span className="pp-salary-summary-value absent-days">
                  {payrollData?.total_absent || 0}
                </span>
              </div>
              <div className="pp-salary-summary-item">
                <span className="pp-salary-summary-label">Holidays</span>
                <span className="pp-salary-summary-value holidays">
                  {payrollData?.total_weekoff || 0}
                </span>
              </div>
            </div>

            <div className="pp-salary-summary-divider"></div>

            <div className="pp-salary-summary-totals">
              <div className="pp-salary-summary-total-item">
                <span className="pp-salary-summary-total-label">
                  Gross Salary
                </span>
                <span className="pp-salary-summary-total-value">
                  ₹{convertThenFormat1(payrollData?.total_basic_salary || 0)}
                </span>
              </div>
              <div className="pp-salary-summary-total-item">
                <span className="pp-salary-summary-total-label">
                  Deductions
                </span>
                <span className="pp-salary-summary-total-value deductions">
                  -₹{convertThenFormat1(payrollData?.total_deduction || 0)}
                </span>
              </div>
              <div className="pp-salary-summary-total-item">
                <span className="pp-salary-summary-total-label">
                  Net Salary
                </span>
                <span className="pp-salary-summary-total-value net-salary">
                  ₹{convertThenFormat1(payrollData?.net_salary || 0)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Attendance Calendar Card */}
        <div
          className={`pp-attendance-calendar-card ${
            formErrors?.selectedDates ? "formError" : ""
          }`}
        >
          <div className="pp-attendance-calendar-header">
            <span className="pp-attendance-calendar-icon">📅</span>
            <h4 className="pp-attendance-calendar-title">
              Attendance Calendar
              {formValues.action === "reject" && selectedDates.length > 0 && (
                <span className="pp-selected-dates-count">
                  ({selectedDates.length} selected)
                </span>
              )}
            </h4>
          </div>

          <div className="pp-attendance-calendar-content">
            <div className="pp-attendance-calendar-navigation">
              <span className="pp-attendance-calendar-month-year">
                {currentMonth.toLocaleDateString("en-US", {
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </div>

            <div className="pp-attendance-calendar-grid">
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
                <div key={day} className="pp-attendance-calendar-weekday">
                  {day}
                </div>
              ))}

              {getDaysInMonth(currentMonth).map((day, index) => {
                const attendanceType = day.isCurrentMonth
                  ? getAttendanceType(day.fullDate)
                  : "";
                const isSelected = selectedDates.includes(
                  day.fullDate.toDateString()
                );

                return (
                  <div
                    key={index}
                    className={`pp-attendance-calendar-day ${
                      !day.isCurrentMonth ? "other-month" : ""
                    } ${attendanceType} ${isSelected ? "selected" : ""}`}
                    onClick={() =>
                      day.isCurrentMonth && handleDateClick(day.fullDate)
                    }
                  >
                    {day.date}
                  </div>
                );
              })}
            </div>

            <div className="pp-attendance-legend">
              <h5 className="pp-attendance-legend-title">Legend:</h5>
              <div className="pp-attendance-legend-grid">
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator present"></div>
                  <span className="pp-attendance-legend-text">Present</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator half-day"></div>
                  <span className="pp-attendance-legend-text">Half Day</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator absent"></div>
                  <span className="pp-attendance-legend-text">Absent</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator weekoff"></div>
                  <span className="pp-attendance-legend-text">Week Off</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator leave"></div>
                  <span className="pp-attendance-legend-text">Leave</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator saturday"></div>
                  <span className="pp-attendance-legend-text">Saturday</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator sunday"></div>
                  <span className="pp-attendance-legend-text">Sunday</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator rostered"></div>
                  <span className="pp-attendance-legend-text">Rostered</span>
                </div>
                <div className="pp-attendance-legend-item">
                  <div className="pp-attendance-legend-indicator late"></div>
                  <span className="pp-attendance-legend-text">Late</span>
                </div>
              </div>
            </div>
            {formErrors?.selectedDates && (
              <span className="pp-approval-error">
                {formErrors.selectedDates}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Selected Dates Details - Moved outside the cards wrapper */}
      {selectedDates.length > 0 && (
        <div className="pp-selected-dates-details">
          <h5 className="pp-selected-dates-title">
            Selected Dates for Discrepancy ({selectedDates.length} dates)
          </h5>

          <div className="pp-selected-dates-list">
            {selectedDates.map((dateString, index) => {
              const date = new Date(dateString);
              const dayName = date.toLocaleDateString("en-US", {
                weekday: "short",
              });
              const dayNumber = date.getDate();
              const monthName = date.toLocaleDateString("en-US", {
                month: "short",
              });
              const year = date.getFullYear();

              return (
                <div key={index} className="pp-selected-date-item">
                  <div className="pp-selected-date-badge">
                    <span className="pp-selected-date-day">{dayName}</span>
                    <span className="pp-selected-date-number">{dayNumber}</span>
                  </div>
                  <div className="pp-selected-date-info">
                    <span className="pp-selected-date-full">
                      {monthName} {dayNumber}, {year}
                    </span>
                    <span className="pp-selected-date-weekday">
                      {dayName}day
                    </span>
                  </div>
                  <button
                    type="button"
                    className="pp-selected-date-remove"
                    onClick={() => handleDateClick(date)}
                    title="Remove this date"
                  >
                    ×
                  </button>
                </div>
              );
            })}
          </div>
          <div className="pp-selected-dates-actions">
            <button
              type="button"
              className="pp-clear-all-dates-btn"
              onClick={() => setSelectedDates([])}
            >
              Clear All Dates
            </button>
          </div>
        </div>
      )}

      {/* Discrepancy Section - Only show when staff selects reject */}
      {selectedDates.length > 0 &&
        approvalType === "staff" &&
        formValues.action === "reject" && (
          <div className="pp-discrepancy-section">
            <div className="pp-discrepancy-card">
              <div className="pp-discrepancy-header">
                <h4 className="pp-discrepancy-title">Report Discrepancy</h4>
                <p className="pp-discrepancy-subtitle">
                  Please select the type of discrepancy found and upload proof
                  if available
                </p>
              </div>

              <div className="pp-discrepancy-content">
                <div className="pp-discrepancy-types-section">
                  <label className="pp-discrepancy-section-label">
                    Discrepancies{" "}
                    <span className="pp-approval-required">*</span>
                  </label>

                  <div className="pp-individual-date-discrepancies">
                    {selectedDates.map((dateString) => {
                      const date = new Date(dateString);
                      const dayName = date.toLocaleDateString("en-US", {
                        weekday: "long",
                      });
                      const dayNumber = date.getDate();
                      const monthName = date.toLocaleDateString("en-US", {
                        month: "short",
                      });
                      const dateData = dateDiscrepancies[dateString] || {
                        discrepancyTypes: "",
                        proofImages: [],
                        remarks: "",
                      };

                      // Check if this date has validation error (no discrepancy type selected)
                      const hasDiscrepancyError =
                        !dateData.discrepancyTypes ||
                        dateData.discrepancyTypes.trim() === "";

                      return (
                        <div
                          key={dateString}
                          className={`pp-date-discrepancy-item ${
                            hasDiscrepancyError ? "formError" : ""
                          }`}
                        >
                          <div className="pp-date-discrepancy-header">
                            <div className="pp-date-discrepancy-badge">
                              <span className="pp-date-discrepancy-day">
                                {dayName}
                              </span>
                              <span className="pp-date-discrepancy-number">
                                {dayNumber}
                              </span>
                              <span className="pp-date-discrepancy-month">
                                {monthName}
                              </span>
                            </div>
                            <div className="pp-date-discrepancy-info">
                              <h6 className="pp-date-discrepancy-title">
                                {dayName}, {monthName} {dayNumber}
                              </h6>
                              <p className="pp-date-discrepancy-subtitle">
                                Select discrepancy type(s) and upload proof
                                images
                              </p>
                            </div>
                          </div>

                          {/* Current Attendance Status for this date */}
                          <div className="pp-date-discrepancy-current-status">
                            <label className="pp-date-discrepancy-label">
                              Current Attendance Status
                            </label>
                            <div className="pp-date-discrepancy-status-display">
                              {(() => {
                                const currentDateString = moment
                                  .tz(new Date(dateString), "Asia/Kolkata")
                                  .format("YYYY-MM-DD");
                                const currentDayData = allData.calander?.find(
                                  (day) => day.date === currentDateString
                                );

                                if (!currentDayData)
                                  return (
                                    <span className="pp-status-unknown">
                                      No attendance data
                                    </span>
                                  );

                                let statusText = "";
                                let statusClass = "";

                                if (currentDayData.is_leave_day === true) {
                                  statusText = "Leave";
                                  statusClass = "status-leave";
                                } else if (currentDayData.is_weekoff === true) {
                                  statusText = "Week Off";
                                  statusClass = "status-weekoff";
                                } else if (currentDayData.is_sunday === true) {
                                  statusText = "Sunday";
                                  statusClass = "status-sunday";
                                } else if (
                                  currentDayData.is_saturday === true
                                ) {
                                  statusText = "Saturday";
                                  statusClass = "status-saturday";
                                } else if (
                                  currentDayData.is_rostered_day === true
                                ) {
                                  statusText = "Rostered";
                                  statusClass = "status-rostered";
                                } else if (
                                  currentDayData.is_half_day === true
                                ) {
                                  statusText = "Half Day";
                                  statusClass = "status-half";
                                } else if (
                                  currentDayData.is_late === true &&
                                  currentDayData.is_present === true
                                ) {
                                  statusText = "Late";
                                  statusClass = "status-late";
                                } else if (currentDayData.is_present === true) {
                                  statusText = "Present";
                                  statusClass = "status-present";
                                } else if (currentDayData.is_absent === true) {
                                  statusText = "Absent";
                                  statusClass = "status-absent";
                                } else {
                                  statusText = "No Record";
                                  statusClass = "status-unknown";
                                }

                                return (
                                  <div
                                    className={`pp-current-status-badge ${statusClass}`}
                                  >
                                    <span className="pp-status-icon">📊</span>
                                    <span className="pp-status-text">
                                      {statusText}
                                    </span>
                                  </div>
                                );
                              })()}
                            </div>
                          </div>

                          {/* Discrepancy Types for this date */}
                          <div className="pp-date-discrepancy-types">
                            <label className="pp-date-discrepancy-label">
                              Discrepancy Type{" "}
                              <span className="pp-approval-required">*</span>
                            </label>
                            <div className="pp-date-discrepancy-types-grid">
                              {discrepancyOptions.map((option) => (
                                <div
                                  key={option.id}
                                  className="pp-date-discrepancy-type-item"
                                >
                                  <label className="pp-discrepancy-radio-label">
                                    <input
                                      type="radio"
                                      name={`discrepancy-${dateString}`}
                                      className="pp-discrepancy-radio"
                                      checked={
                                        dateData.discrepancyTypes === option.id
                                      }
                                      onChange={() =>
                                        handleDiscrepancyChange(
                                          dateString,
                                          option.id
                                        )
                                      }
                                    />
                                    <span className="pp-discrepancy-radio-custom"></span>
                                    <span className="pp-discrepancy-radio-text">
                                      {option.label}
                                    </span>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Remarks for this date */}
                          <div className="pp-date-discrepancy-remarks">
                            <label className="pp-date-discrepancy-label">
                              Remarks{" "}
                              <span className="pp-approval-required">*</span>
                            </label>
                            <textarea
                              value={dateData.remarks || ""}
                              onChange={(e) =>
                                handleRemarksChange(dateString, e.target.value)
                              }
                              placeholder={`Enter remarks for ${dayName}, ${monthName} ${dayNumber}...`}
                              className={`pp-date-discrepancy-remarks-textarea ${
                                !dateData.remarks ||
                                dateData.remarks.trim().length === 0
                                  ? "formError"
                                  : ""
                              }`}
                              rows={3}
                              maxLength={300}
                            />
                            <div className="pp-date-discrepancy-remarks-footer">
                              <span className="pp-date-discrepancy-remarks-counter">
                                {(dateData.remarks || "").length}/300 characters
                              </span>
                            </div>
                          </div>

                          <div className="pp-date-discrepancy-images">
                            <label className="pp-date-discrepancy-label">
                              Upload Proof Images{" "}
                              <span className="pp-approval-required">*</span>
                            </label>

                            <div
                              className={`pp-date-discrepancy-upload-area ${
                                (!dateData.proofImages ||
                                  dateData.proofImages.length === 0) &&
                                hasDiscrepancyError
                                  ? "formError"
                                  : ""
                              }`}
                            >
                              <input
                                type="file"
                                id={`proof-images-${dateString}`}
                                multiple
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageUpload(e, dateString)
                                }
                                className="pp-discrepancy-file-input"
                                disabled={uploadingImages[dateString]}
                              />
                              <label
                                htmlFor={`proof-images-${dateString}`}
                                className="pp-discrepancy-upload-label"
                              >
                                <div className="pp-discrepancy-upload-icon">
                                  {uploadingImages[dateString] ? <HourglassIcon /> : <CloudUploadIcon />}
                                </div>
                                <div className="pp-discrepancy-upload-text">
                                  <span className="pp-discrepancy-upload-primary">
                                    {uploadingImages[dateString]
                                      ? "Uploading..."
                                      : "Click to upload images"}
                                  </span>
                                  <span className="pp-discrepancy-upload-secondary">
                                    {uploadingImages[dateString]
                                      ? "Please wait"
                                      : "or drag and drop"}
                                  </span>
                                </div>
                              </label>
                            </div>

                            {/* Uploaded Images Preview for this date */}
                            {dateData.proofImages.length > 0 && (
                              <div className="pp-date-discrepancy-images-preview">
                                <h6 className="pp-discrepancy-preview-title">
                                  Uploaded Images ({dateData.proofImages.length}
                                  /5)
                                </h6>
                                <div className="pp-discrepancy-images-grid">
                                  {dateData.proofImages.map((image) => (
                                    <div
                                      key={image.id}
                                      className="pp-discrepancy-image-item"
                                    >
                                      <img
                                        src={image.preview}
                                        alt="Proof"
                                        className="pp-discrepancy-image-preview"
                                      />
                                      <button
                                        type="button"
                                        className="pp-discrepancy-image-remove"
                                        onClick={() =>
                                          removeImage(dateString, image.id)
                                        }
                                      >
                                        ×
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {formErrors?.discrepancyTypes && (
                    <span className="pp-approval-error">
                      {formErrors.discrepancyTypes}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default DiscrepancyForm;
